import { useTranslation } from 'react-i18next';
import useCrudMutation from 'hooks/useCrudMutation';
import { documentService } from 'domain/documents/api/documentService';
import { favoriteDocumentsQueryKey } from 'domain/documents/hooks/useGetFavoriteDocuments';

export default function useRemoveFavoriteDocument() {
  const { t } = useTranslation('genericItem');

  return useCrudMutation({
    mutationFn: documentService.removeFavorite,
    successMessage: t('removeFavoriteMessage'),
    errorMessage: t('failedToRemoveFavoriteMessage'),
    invalidateKeys: [[favoriteDocumentsQueryKey]],
  });
}
